import Swiper, {Navigation} from "../../assets/.npm/node_modules/swiper";

export default () => {
  let swiperOtherPro = new Swiper(".slider-other-product", {
    modules: [Navigation],
    slidesPerView: 1, 
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: ".other-product-next",
      prevEl: ".other-product-prev",
    }, 
    breakpoints: {
        580: {
            slidesPerView: 2, 
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
    },
  });
}
  
